import script from "./SerialView.vue?vue&type=script&setup=true&lang=js"
export * from "./SerialView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__